<template>
  <!-- @vue-skip TODO: 既存の型エラーを解消したら外す -->
  <div class="applicant-detail">
    <!-- Twitterの場合-->
    <div v-if="snsType === 'twitter'" layout>
      <!-- Twitterで確認-->
      <el-tooltip :enterable="false" placement="top" content="Xで確認">
        <template v-if="post.postType === 'retweet'"
          ><a :href="'https://x.com/' + post.screenName" target="_new">
            <el-button class="is-primary-button el-button--icon" type="default"
              ><i class="mdi mdi-open-in-new"></i></el-button></a
        ></template>
        <template v-else
          ><a :href="'https://x.com/' + post.screenName + '/status/' + post.id" target="_new">
            <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
        ></template>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-if="campaignType !== 'old_web_instantwin'"
        placement="top"
        :content="widgetTooltipContent"
      >
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isWidget === 0 ? 'default' : 'primary'"
            :disabled="isWidgetDisabled"
            @click="changeIsWidget"
            ><i class="mdi mdi-view-module"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="candidateTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isCandidate === 0 ? 'default' : 'primary'"
            :disabled="isCandidateDisabled"
            @click="changeIsCandidate"
            ><i class="mdi mdi-star"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="winnerTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isWinner === 0 ? 'default' : 'primary'"
            :disabled="isWinnerDisabled"
            @click="changeIsWinner"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- NG追加/解除ボタン -->
      <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isNg === 1 ? 'primary' : 'default'"
            @click="changeNg"
            ><i class="mdi mdi-cancel"></i
          ></el-button>
        </div>
      </el-tooltip>
    </div>
    <!-- Instagramの場合-->
    <div v-if="snsType === 'instagram'" layout>
      <!-- Instagramで確認-->
      <el-tooltip :enterable="false" placement="top" :content="'Instagramで確認'">
        <template
          ><a :href="post.permalink" target="_new">
            <el-button class="is-primary-button el-button--icon" type="default"
              ><i class="mdi mdi-open-in-new"></i></el-button></a
        ></template>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="widgetTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isWidget === 0 ? 'default' : 'primary'"
            :disabled="isWidgetDisabled"
            @click="changeIsWidget"
            ><i class="mdi mdi-view-module"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="candidateTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isCandidate === 0 ? 'default' : 'primary'"
            :disabled="isCandidateDisabled"
            @click="changeIsCandidate"
            ><i class="mdi mdi-star"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="winnerTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isWinner === 0 ? 'default' : 'primary'"
            :disabled="isWinnerDisabled"
            @click="changeIsWinner"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- NG追加/解除ボタン -->
      <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isNg === 1 ? 'primary' : 'default'"
            @click="changeNg"
            ><i class="mdi mdi-cancel"></i
          ></el-button>
        </div>
      </el-tooltip>
    </div>
    <!-- TikTokの場合-->
    <div v-if="snsType === 'tiktok'" layout>
      <!-- TikTokで確認-->
      <el-tooltip :enterable="false" placement="top" content="Tiktokで確認">
        <template
          ><a :href="'https://tiktok.com/@' + post.screenName" target="_new">
            <el-button class="is-primary-button el-button--icon" type="default"
              ><i class="mdi mdi-open-in-new"></i></el-button></a
        ></template>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="candidateTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isCandidate === 0 ? 'default' : 'primary'"
            :disabled="isCandidateDisabled"
            @click="changeIsCandidate"
            ><i class="mdi mdi-star"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" placement="top" :content="winnerTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isWinner === 0 ? 'default' : 'primary'"
            :disabled="isWinnerDisabled"
            @click="changeIsWinner"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- NG追加/解除ボタン -->
      <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent">
        <div>
          <el-button
            class="is-primary-button ml-button el-button--icon"
            :type="post.isNg === 1 ? 'primary' : 'default'"
            @click="changeNg"
            ><i class="mdi mdi-cancel"></i
          ></el-button>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-button {
  position: relative;
}

.badge {
  right: -4px;
  bottom: 0;
}

.ml-button {
  margin-left: $spacing-unit + 2;
}

.is-primary-button:focus {
  color: $text-color;
  background: #fff;
  border: 1px solid $border-color;
}

.is-primary-button.el-button--primary:focus {
  color: #fff;
  background-color: $primary-color;
  border-color: $primary-color;
}
</style>
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent, PropType } from 'vue'

import { useSystemStore } from '@/client/store/useSystemStore'

type SnsType = 'instagram' | 'twitter'

export default defineComponent({
  props: {
    snsType: { type: String as PropType<SnsType>, required: true },
    post: { type: Object as PropType<any>, required: true },
    campaignType: String
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(useSystemStore, {
      isEndContract: state => (state.currentGroup ? state.currentGroup.contractStatus === 3 : false)
    }),

    isWidgetDisabled() {
      return Boolean(this.isEndContract || (this.post.isNg && !this.post.isWidget))
    },

    isCandidateDisabled() {
      return Boolean(this.isEndContract || (this.post.isNg && !this.post.isCandidate))
    },

    isWinnerDisabled() {
      // XのみDM送信中の場合は変更できない
      if (this.post?.isDmSending) {
        return true
      }

      return Boolean(this.isEndContract || (this.post.isNg && !this.post.isWinner))
    },

    widgetTooltipContent() {
      if (this.post.isNg && !this.post.isWidget) {
        return 'NGアカウント'
      }

      return this.post.isWidget ? 'ウィジェットから削除' : 'ウィジェットに追加'
    },

    candidateTooltipContent() {
      if (this.post.isNg && !this.post.isCandidate) {
        return 'NGアカウント'
      }

      return this.post.isCandidate ? '候補者を解除' : '候補者に追加'
    },

    winnerTooltipContent() {
      if (this.post?.isDmSending) {
        return 'DM送信中のため変更できません'
      }

      if (this.post.isNg && !this.post.isWinner) {
        return 'NGアカウント'
      }

      return this.post.isWinner ? '当選者を解除' : '当選者に追加'
    },

    ngTooltipContent() {
      return this.post.isNg === 1 ? 'NGアカウントを解除' : 'NGアカウントに追加'
    }
  },
  methods: {
    /**
     * ウィジェットフラグを変更
     */
    changeIsWidget() {
      if ((this.post.isNg && !this.post.isWidget) || this.isEndContract) {
        return
      }

      this.$emit('change_is_widget')
    },

    /**
     * 候補者フラグを変更
     */
    changeIsCandidate() {
      if ((this.post.isNg && !this.post.isCandidate) || this.isEndContract) {
        return
      }

      this.$emit('change_is_candidate')
    },

    /**
     * 当選者フラグを変更
     */
    changeIsWinner() {
      if ((this.post.isNg && !this.post.isWinner) || this.isEndContract) {
        return
      }

      this.$emit('change_is_winner')
    },

    /**
     * NGアカウントフラグを変更
     */
    changeNg() {
      this.$emit('change_ng', {
        screenName: this.post.screenName,
        isNg: this.post.isNg === 0,
        ngApplicantId: this.post.ngApplicantId ?? null
      })
    }
  }
})
</script>
